<template>
  <div>
    <section class="" v-if="DonateTicketData.Tickets != null">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'OrderList' }"
              tag="button"
              class="active"
            >
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main">
          <div class="bg-box">
            <h1>{{ $t("受贈票卡") }}</h1>
          </div>
          <div class="bg-box">
            <ul class="text-box">
              <li class="single-item">
                <ul
                  class=""
                  v-for="Ticket in DonateTicketData.Tickets"
                  :key="Ticket.TId"
                >
                  <li>
                    <div class="qr-box">
                      <img src="img/qrcode-pic.svg" alt="" />
                      <p
                        v-if="
                          !Ticket.IsUsing &&
                          !Ticket.IsExpired &&
                          !Ticket.IsRefunded &&
                          Ticket.DonateStatus == 2
                        "
                      >
                        {{ $t("尚未啟用") }}
                      </p>
                      <p
                        v-if="
                          !Ticket.IsUsing &&
                          !Ticket.IsExpired &&
                          !Ticket.IsRefunded &&
                          Ticket.DonateStatus == 1
                        "
                      >
                        {{ $t("等待驗證中") }}
                      </p>
                      <p v-if="Ticket.IsExpired && Ticket.DonateStatus == 2">
                        {{ $t("已過期") }}
                      </p>
                    </div>
                  </li>
                  <li class="btn-box">
                    <button
                      v-if="
                        !Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        !Ticket.IsRefunded &&
                        (Ticket.DonateStatus == 1 || Ticket.DonateStatus == 2)
                      "
                      @click="ticketDonateCancel(Ticket.TId)"
                    >
                      {{ $t("退回票卡") }}
                    </button>
                    <button
                      v-if="
                        !Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        !Ticket.IsRefunded &&
                        Ticket.DonateStatus == 1
                      "
                      @click="ticketDonateCheck(Ticket.TId)"
                    >
                      {{ $t("輸入驗證碼") }}
                    </button>
                    <button
                      v-if="
                        (DonateTicketData.Ticket == null ||
                          DonateTicketData.CanActiveNewTicket) &&
                        !Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        !Ticket.IsRefunded &&
                        Ticket.DonateStatus == 2
                      "
                      @click="ticketActive(Ticket.TId, Ticket.Product.Name)"
                    >
                      {{ $t("立即啟用") }}
                    </button>
                  </li>
                  <!-- 0620 新增 -->
                  <hr />
                  <li>
                    <div>{{ $t("商品名稱") }}</div>
                    <div>{{ Ticket.Product.Name }}</div>
                  </li>
                  <li>
                    <div>{{ $t("類型") }}</div>
                    <div class="circle-border">{{ $t("時數票(QR Code)") }}</div>
                  </li>
                  <li>
                    <div>{{ $t("品項") }}</div>
                    <div class="circle-border">
                      {{ Ticket.Product.Time }}{{ $t("小時") }}
                    </div>
                  </li>
                  <hr />
                  <li>
                    <div>{{ $t("結束時間") }}</div>
                    <div
                      class="time"
                      v-if="
                        Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        Ticket.DonateStatus == 2
                      "
                    >
                      {{ timeString(Ticket.ExpireTime, "YYYY/MM/DD HH:mm") }}
                    </div>
                    <div
                      class="time"
                      v-if="
                        Ticket.IsUsing &&
                        Ticket.IsExpired &&
                        Ticket.DonateStatus == 2
                      "
                    >
                      {{ timeString(Ticket.ExpireTime, "YYYY/MM/DD HH:mm") }}
                      ({{ $t("已過期, 僅可出站") }})
                    </div>
                    <div
                      class="time"
                      v-if="
                        !Ticket.IsUsing &&
                        Ticket.IsExpired &&
                        Ticket.DonateStatus == 2
                      "
                    >
                      {{ timeString(Ticket.ExpireTime, "YYYY/MM/DD HH:mm") }}
                      ({{ $t("已過期") }})
                    </div>
                    <div
                      class="time"
                      v-if="
                        !Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        !Ticket.IsRefunded &&
                        Ticket.DonateStatus == 2
                      "
                    >
                      {{ $t("尚未啟用") }}
                    </div>
                    <div
                      class="time"
                      v-if="
                        !Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        !Ticket.IsRefunded &&
                        Ticket.DonateStatus == 1
                      "
                    >
                      {{ $t("等待驗證") }}
                    </div>
                  </li>
                  <li
                    v-if="
                      (Ticket.IsUsing || Ticket.IsExpired) &&
                      Ticket.DonateStatus == 2
                    "
                  >
                    <div>YouBike ({{ $t("點選序號進行複製") }})</div>
                    <div
                      @click="
                        copyYouBike(
                          Ticket.voucher_uuid + '|' + Ticket.voucher_url
                        )
                      "
                    >
                      {{ Ticket.voucher_uuid }}
                    </div>
                  </li>
                  <li
                    v-if="
                      (Ticket.IsUsing || Ticket.IsExpired) &&
                      Ticket.DonateStatus == 2
                    "
                  >
                    <div>QR No.</div>
                    <div class="box">
                      {{ Ticket.CardId }}
                      <router-link
                        :to="{ name: 'TicketLog', params: { TId: Ticket.TId } }"
                        tag="button"
                      >
                        {{ $t("搭乘紀錄") }}
                      </router-link>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "受贈票卡": "受贈票卡",
    "尚未啟用": "尚未啟用",
    "等待驗證中": "等待驗證中",
    "已過期": "已過期",
    "退回票卡": "退回票卡",
    "輸入驗證碼": "輸入驗證碼",
    "立即啟用": "立即啟用",
    "搭乘紀錄": "搭乘紀錄",
    "等待驗證": "等待驗證",
    "結束時間": "結束時間",
    "已過期(僅可出站)": "已過期(僅可出站)",
    "名稱": "名稱",
    "類型": "類型",
    "品項": "品項",
    "贈與者": "贈與者",
    "錯誤": "錯誤",
    "取得受贈票卡過程發生錯誤, 請稍後再試一次": "取得受贈票卡過程發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "請再次確認": "請再次確認",
    "您即將啟用「」，請問是否確定啟用？": "您即將啟用「」，請問是否確定啟用？",
    "取消": "取消",
    "啟用票卡過程發生錯誤, 請稍後再試一次": "啟用票卡過程發生錯誤, 請稍後再試一次",
    "啟用成功": "啟用成功",
    "請輸入轉贈碼": "請輸入轉贈碼",
    "驗證過程發生錯誤, 請稍後再試一次": "驗證過程發生錯誤, 請稍後再試一次",
    "驗證成功": "驗證成功",
    "票卡驗證完成": "票卡驗證完成",
    "退回票卡過程發生錯誤, 請稍後再試一次": "退回票卡過程發生錯誤, 請稍後再試一次",
    "退回票卡成功": "退回票卡成功",
    "已退回票卡": "已退回票卡",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
  en: {
    "受贈票卡": "Gift pass",
    "尚未啟用": "Not enabled yet",
    "等待驗證中": "Verification pending",
    "已過期": "Expired",
    "退回票卡": "Return the pass",
    "輸入驗證碼": "Enter the verification code",
    "立即啟用": "Enable",
    "搭乘紀錄": "Transportation record",
    "等待驗證": "To be verified",
    "結束時間": "End time",
    "已過期(僅可出站)": "Expired (for exit only)",
    "名稱": "Name",
    "類型": "Type",
    "品項": "Item",
    "贈與者": "Giver",
    "錯誤": "Error",
    "取得受贈票卡過程發生錯誤, 請稍後再試一次": "Error. Please try again later.",
    "確定": "Confirm",
    "請再次確認": "Please confirm again.",
    "您即將啟用「」，請問是否確定啟用？": "You're going to enable []. Do you want to enable it?",
    "取消": "Cancel",
    "啟用票卡過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "啟用成功": "Enabled",
    "請輸入轉贈碼": "Please enter the redeem code",
    "驗證過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "驗證成功": "Verified",
    "票卡驗證完成": "Pass verified",
    "退回票卡過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "退回票卡成功": "Pass returned successfully",
    "已退回票卡": "Pass returned",
    "卡片交易紀錄": "Activity",
    "減碳計算": "Carbon Reduced",
  },
  jp: {
    "受贈票卡": "受贈票卡",
    "尚未啟用": "尚未啟用",
    "等待驗證中": "等待驗證中",
    "已過期": "已過期",
    "退回票卡": "退回票卡",
    "輸入驗證碼": "輸入驗證碼",
    "立即啟用": "立即啟用",
    "搭乘紀錄": "搭乘紀錄",
    "等待驗證": "等待驗證",
    "結束時間": "結束時間",
    "已過期(僅可出站)": "已過期(僅可出站)",
    "名稱": "名稱",
    "類型": "類型",
    "品項": "品項",
    "贈與者": "贈與者",
    "錯誤": "錯誤",
    "取得受贈票卡過程發生錯誤, 請稍後再試一次": "取得受贈票卡過程發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "請再次確認": "請再次確認",
    "您即將啟用「」，請問是否確定啟用？": "您即將啟用「」，請問是否確定啟用？",
    "取消": "取消",
    "啟用票卡過程發生錯誤, 請稍後再試一次": "チケットの使用中にエラーが発生しました,時間をおいてから再度お試しください",
    "啟用成功": "今すぐ使用できます",
    "請輸入轉贈碼": "転送コードを入力してください",
    "驗證過程發生錯誤, 請稍後再試一次": "認証中にエラーが発生しました,時間をおいてから再度お試しください",
    "驗證成功": "認証に成功しました",
    "票卡驗證完成": "チケット認証が完了しました",
    "退回票卡過程發生錯誤, 請稍後再試一次": "チケットの払い戻し中にエラーが発生しました,時間をおいてから再度お試しください",
    "退回票卡成功": "チケットの払い戻しに成功しました",
    "已退回票卡": "すでにチケットの払い戻しが完了しています",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "DonateTicket",
  i18n,
  data() {
    return {
      DonateTicketData: {},
      local: "zh_tw",
    };
  },
  created: function () {
    let that = this;
    $.ajax({
      url:
        that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/DonateTicket",
      //url: "https://localhost:44321/Html/OrderInfo",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得受贈票卡過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.DonateTicketData = JSON.parse(res.data);
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-order-main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  updated: function () {
    if ($(".single-item")) {
      $(".single-item").slick({});
    }
  },
  methods: {
    timeAdd(time, hours) {
      return moment(time).add(hours, "hours");
    },
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
    ticketActive(TId, ProductName) {
      let that = this;
      that
        .$swal({
          heightAuto: false,
          icon: "warning",
          title: that.$t("請再次確認"),
          text:
            that.$t("您即將啟用「") +
            ProductName +
            that.$t("」，請問是否確定啟用?"),
          showCancelButton: true,
          confirmButtonText: that.$t("確定"),
          cancelButtonText: that.$t("取消"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/TicketActive",
              //url: "https://localhost:44321/Html/TicketActive",
              type: "post",
              data: {
                TId: TId,
                token: Storage.get("ek_login_token"),
              },
              dataType: "json",
              error: function () {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: that.$t("啟用票卡過程發生錯誤, 請稍後再試一次"),
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("啟用成功"),
                    showConfirmButton: false,
                    timer: 1500,
                    willClose: function () {
                      that.$router.push({
                        name: "QRCode",
                        params: {},
                      });
                      // 重新整理畫面
                      //location.reload();
                    },
                    allowOutsideClick: false,
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  if (res.toekn_error) {
                    that.$swal({
                      heightAuto: false,
                      title: that.$t("錯誤"),
                      text: error_msg[i18n.locale],
                      icon: "error",
                      allowOutsideClick: false,
                      willClose: function () {
                        // 移除登入資訊
                        Storage.remove("ek_login_token");
                        // 回到首頁
                        that.$router.push({
                          name: "Home",
                          params: {},
                        });
                      },
                    });
                  } else {
                    that.$swal({
                      heightAuto: false,
                      title: that.$t("錯誤"),
                      text: error_msg[i18n.locale],
                      icon: "error",
                      allowOutsideClick: false,
                      confirmButtonText: that.$t("確定"),
                    });
                  }
                }
              },
            });
          }
        });
    },
    ticketDonateCheck(TId) {
      let that = this;
      that
        .$swal({
          heightAuto: false,
          title: that.$t("請輸入轉贈碼"),
          input: "text",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: that.$t("確定"),
          cancelButtonText: that.$t("取消"),
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: (code) => {
            return {
              TId: TId,
              code: code,
              token: Storage.get("ek_login_token"),
            };
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/TicketDonateCheck",
              type: "post",
              data: {
                TId: result.value.TId,
                code: result.value.code,
                token: result.value.token,
              },
              dataType: "json",
              error: function () {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: that.$t("驗證過程發生錯誤, 請稍後再試一次"),
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("驗證成功"),
                    text: that.$t("票卡驗證完成"),
                    confirmButtonText: that.$t("確定"),
                    willClose: function () {
                      // 重新整理畫面
                      location.reload();
                    },
                    allowOutsideClick: false,
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              },
            });
          }
        });
    },
    ticketDonateCancel(TId) {
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/TicketDonateCancel",
        type: "post",
        data: {
          TId: TId,
          token: Storage.get("ek_login_token"),
        },
        dataType: "json",
        error: function () {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("退回票卡過程發生錯誤, 請稍後再試一次"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("退回票卡成功"),
              text: that.$t("已退回票卡"),
              confirmButtonText: that.$t("確定"),
              willClose: function () {
                // 重新整理畫面
                location.reload();
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
    gotoTicketLog(TId) {
      this.$router.push({
        name: "TicketLog",
        params: { TId: TId },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DonateTicket.vue